import { redirect } from "@tanstack/react-router";

import { logLogoutInvalidUser } from "@/lib/breadcrumbs";
import { shouldShowGeneralTermsPage } from "@/lib/general-terms";
import type { RouteGuard } from "@/routes/-root/root-guards";

export const guardInvalidPerfil: RouteGuard = async ({ context, location }) => {
  if (context.user.codPerfil !== 3) {
    logLogoutInvalidUser({ location, reason: "Invalid codPerfil" });
    await context.authClient.logout();
    throw new Error("Usuário não autorizado.");
  }
};

export const guardGeneralTerms: RouteGuard = async ({ context, location }) => {
  const shouldRedirect = await shouldShowGeneralTermsPage(context);

  if (shouldRedirect && location.pathname !== "/general-terms") {
    redirect({
      to: "/general-terms",
      search: { redirect: location.href },
      throw: true,
    });
  }
};

export const guardMissingPaymentCard: RouteGuard = ({ context, location }) => {
  if (
    context.flags["bloqueia-uso-do-app-se-nao-possui-cartao-cadastrado"] &&
    context.user.possuiCartaoPendente &&
    !location.pathname.startsWith("/add-payment-card")
  ) {
    redirect({
      to: "/add-payment-card",
      search: { redirect: location.href },
      throw: true,
    });
  }
};

export const guardMissingFlows: RouteGuard = ({ context, location }) => {
  const hasMandatoryPendingFlows =
    context.flags["redireciona-usuario-para-fluxos-se-pendente"] &&
    context.user.fluxosPendentes.length > 0 &&
    context.user.fluxosPendentes.some((flow) => flow.obrigatorio);

  if (hasMandatoryPendingFlows && !location.pathname.startsWith("/flows")) {
    redirect({
      to: "/flows",
      search: { redirect: location.href },
      throw: true,
    });
  }

  if (!hasMandatoryPendingFlows && location.pathname === "/flows") {
    redirect({
      to: "/",
      throw: true,
    });
  }
};

export const guardCafDocumentsReprovado: RouteGuard = ({ context, location }) => {
  const isReprovado = context.user.statusDocumentosCaf?.toLowerCase() === "reprovado";

  if (isReprovado && !location.pathname.startsWith("/caf-documents-blocked")) {
    redirect({
      to: "/caf-documents-blocked",
      throw: true,
    });
  }

  if (!isReprovado && location.pathname.startsWith("/caf-documents-blocked")) {
    redirect({
      to: "/",
      throw: true,
    });
  }
};
